module.exports = __webpack_public_path__ + "img/experienciapersonal.1efb3f82.png";